import { api, handleError } from "./baseApi";

export async function addRoute(payload) {
  try {
    const formattedPayload = {
      ...payload,
      total_trips: Number(payload.total_trips) || 0,
      total_uptrips: Number(payload.total_uptrips) || 0,
      total_downtrips: Number(payload.total_downtrips) || 0,
    };

    const { data } = await api.post("/bus-route", formattedPayload);
    return data;
  } catch (error) {
    return handleError(error, "Failed to add route");
  }
}

export async function getRouteById(routeId) {
  try {
    const { data } = await api.get(`/bus-route/${routeId}`);
    return data;
  } catch (error) {
    return handleError(error, "Failed to fetch route");
  }
}

export async function searchRoute(source, destination) {
  try {
    const { data } = await api.get("/bus-route/search", {
      params: { source, destination },
    });
    return data;
  } catch (error) {
    return handleError(error, "Failed to search route");
  }
}

export async function getFareTable(busId, routeId) {
  try {
    const { data } = await api.get("/bus-route/fare-table", {
      params: { bus_id: busId, route_id: routeId },
    });
    return data;
  } catch (error) {
    return handleError(error, "Failed to fetch fare table");
  }
}

export async function patchFareTable(busId, routeId, fares) {
  try {
    const { data } = await api.patch("/bus-stop/add-fare", {
      bus_id: busId,
      route_id: routeId,
      fares,
    });
    return data;
  } catch (error) {
    return handleError(error, "Failed to update fare table");
  }
}

export async function updateRoute(routeId, routeDetails, order_of_stops) {
  try {
    const payload = {
      source: routeDetails.from,
      destination: routeDetails.to,
      via_locations: routeDetails.via,
      total_stops: Number(routeDetails.noOfStops),
      order_of_stops: order_of_stops.map((stop) => ({
        stop: stop.stop,
        time: Number(stop.time),
        distance: Number(stop.distance),
      })),
      total_distance: Number(routeDetails.totalKm),
      total_duration: Number(routeDetails.total_duration),
      min_fare: Number(routeDetails.minimumFare),
      max_fare: Number(routeDetails.maximumFare),
      luggage_fare_per_unit: Number(routeDetails.luggageFare),
      total_trips: Number(routeDetails.total_trips),
      total_uptrips: Number(routeDetails.total_uptrips),
      total_downtrips: Number(routeDetails.total_downtrips),
    };

    const { data } = await api.put(`/bus-route/${routeId}`, payload);
    return data;
  } catch (error) {
    return handleError(error, "Failed to update route");
  }
}

export async function deleteRoute(routeId) {
  try {
    const { data } = await api.delete(`/bus-route/${routeId}`);
    return data;
  } catch (error) {
    return handleError(error, "Failed to delete route");
  }
}
